import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Meldingstitel invoeren',
    },
    body: {
      label: 'Berichttekst',
      placeholder: 'Voer uw bericht in',
    },
    promo_code: {
      label: 'Promocode',
      placeholder: 'Promocode selecteren',
    },
    offers: {
      label: 'Aanbiedingen',
      placeholder: 'Aanbieding selecteren',
    },
    campaign_type: {
      label: 'Campagnetype',
      placeholder: 'Campagnetype selecteren',
    },
    tone: {
      label: 'Tone of voice',
      placeholder: 'Selecteer een toon',
    },
  },
  attachment: {
    heading: 'Wat moet deze campagne promoten?',
    offer: {
      title: 'Aanbieding',
      description: 'Kies uit uw actieve aanbiedingen.',
    },
    promo_code: {
      title: 'Promocode',
      description: 'Kies uit uw actieve promocodes.',
    },
  },
  buttons: {
    generate: 'Genereren',
    improve: 'Verbeteren met AI',
    undo: 'Ongedaan maken ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Vriendelijk 🙂',
    [ToneTypes.Elegant]: 'Elegant ✨',
    [ToneTypes.Playful]: 'Speels 🎉',
    [ToneTypes.Professional]: 'Professioneel 👨‍💼',
    [ToneTypes.Informative]: 'Informatief 📊',
    [ToneTypes.Persuasive]: 'Overtuigend 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promotioneel 🚀',
    [CampaignTypes.Informational]: 'Informationeel ℹ️',
  },
  no_promo_codes: {
    title: 'Geen geldige promocodes',
    description: 'Maak een nieuwe promocode aan.',
    create_promo_code: 'Promocode aanmaken',
  },
  no_offers: {
    title: 'Geen actieve aanbiedingen',
    description: 'Maak een nieuwe aanbieding aan.',
    create_offer: 'Aanbieding aanmaken',
  },
  feedback: {
    success: 'Succesvol gegenereerd',
    error: 'Genereren mislukt',
  },
};
